<template>
  <div class="main_Container">
    <section class="p-4">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <form>
              <div class="card-body__form">
                <div class="row">
                  <!-- Post Data -->
                  <div class="col-lg-6">
                    <!-- Post Title -->
                    <div class="form-group">
                      <label for="postTitle">العنوان</label>
                      <input
                        type="text"
                        class="form-control"
                        id="postTitle"
                        placeholder="العنوان"
                        required
                        readonly
                        :value="post.title"
                      />
                    </div>
                    <!-- Short Description -->
                    <div class="form-group">
                      <label for="title">وصف قصير</label>
                      <textarea
                        class="form-control"
                        placeholder="وصف قصير"
                        id="title"
                        cols="30"
                        :value="post.short_description"
                        rows="6"
                        readonly
                      ></textarea>
                    </div>
                    <!-- Full Description -->
                    <div class="form-group">
                      <label for="">المحتوى</label>
                      <div class="mt-2">
                        <!-- Text -->
                        <div
                          v-if="post.post_type == 1"
                          v-html="post.description"
                        ></div>
                        <!-- Image -->
                        <div v-if="post.post_type == 2" class="img-container">
                          <img
                            :src="post.file_url"
                            class="img-fluid"
                            alt="post image"
                          />
                        </div>
                        <!-- File -->
                        <div v-if="post.post_type == 3" class="file__container">
                          <a :href="post.file_url"> لرؤيت الملف </a>
                        </div>
                        <!-- Video -->
                        <div v-if="post.post_type == 4" class="file__container">
                          <a :href="post.file_url"> لرؤيت الفيديو </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Post Image -->
                  <div class="col-lg-6">
                    <div class="from-group">
                      <label for="">صورة الخبر</label>
                      <div class="img-container mt-2" v-if="post.thumbnail_url">
                        <img
                          :src="post.thumbnail_url"
                          class="img-fluid"
                          alt="post image"
                        />
                      </div>
                      <div class="img__container mt-2" v-else>
                        <span>لا توجد صورة</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      post_id: this.$route.params.id,
      isloading: true,
      post: {},
    };
  },
  methods: {
    ...mapActions("postsModule", ["getPostById"]),
  },
  async created() {
    this.post = await this.getPostById(this.post_id);
    console.log("post", this.post);
  },
  computed: {
    ...mapGetters("postsModule", ["isLoading"]),
  },
  mounted() {
    this.isloading = this.isLoading;
  },
  watch: {
    isLoading() {
      this.isloading = this.isLoading;
    },
  },
};
</script>

<style lang="scss" >
</style>